import { ActionIcon, ActionIconProps, Tooltip } from "@mantine/core"
import { IconArrowBackUp } from "@tabler/icons-react";

export const ResetToDefaultButton: React.FC<ActionIconProps & { onClick?: () => void, resource?: string }> = ({ resource, ...props }) => {
    
    return (
        <Tooltip label={resource ? `Reset ${resource} to default` : "Reset to default"} withArrow>
            <ActionIcon
                size="xs"
                variant="subtle"
                radius="xl"
                aria-label={resource ? `Reset ${resource} to default` : "Reset to default"}
                color={props.color ?? "gray"}
                {...props}
            >
                <IconArrowBackUp size={14} />
            </ActionIcon>
        </Tooltip>
    )
}